// client/utils.ts
import "../db/Base.js";
function getFullWidthString({
  content,
  important = false
}) {
  if (!content)
    return "100%";
  const padding = content.padding;
  const margin = content.margin;
  if (!padding && !margin)
    return "100%";
  return `calc(100%${padding ? ` - 2 * ${padding}` : ""}${margin ? ` - 2 * ${margin}` : ""})${important ? " !important" : ""}`;
}
export {
  getFullWidthString
};
